import { z } from "zod";

export enum ReferralBonusTypes {
  SIGN_UP = "sign-up",
  ACTIVATION = "activation",
  FLEX_ACTIVATION_OR_HIRING = "flex-activation-or-hiring",
}

export const referralBonusAttributeSchema = z.object({
  name: z.string(),
  program: z.nativeEnum(ReferralBonusTypes),
  compensationPerLicense: z.record(z.string(), z.number()),
});

export const referralBonusSchema = z.object({
  id: z.string(),
  type: z.string(),
  attributes: referralBonusAttributeSchema,
});

export const referralBonusesResponseSchema = z.object({
  data: z.array(referralBonusSchema),
});

export type ReferralBonusesResponse = z.infer<typeof referralBonusesResponseSchema>;
export type ReferralBonus = z.infer<typeof referralBonusSchema>;
